import { login } from '@tencent/wphk-act-base-api';
import { getUserInfo } from '@tencent/wphk-act-base-cgi';
import { to } from '@tencent/wphk-base-utils';
import { url, sessionStorage } from '@tencent/ppd-base-libs';
// 检查sessionStorage是否刚登录过
const IS_HIGH_LOGIN = 'high_login';
// 缓存数据
const HIGH_LOGIN_DATA = 'high_login_data';
// 高授权后跳转携带的字段
const FROM_HIGH_AUTH = 'fromHighAuth';
/**
 * setTimeout的promise实现
 * @param {*} mills
 */
function sleep(mills = 100) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, mills);
    });
}
/**
 * 是否来自高授权的刷新
 * @returns
 */
function isFromHighAuth() {
    return location.href.includes(FROM_HIGH_AUTH);
}
/**
 * 拼接高授权的回调地址
 * @returns
 */
function formatLocaltionUrl() {
    const curUrl = location.href;
    if (curUrl.includes(FROM_HIGH_AUTH)) {
        return curUrl;
    }
    return url.addUrlParam(curUrl, FROM_HIGH_AUTH, 1);
}
/**
 * 处理登录
 * @param actId 检查的活动 id
 * @returns
 */
function handleLogin(actId) {
    return new Promise(async (resolve, reject) => {
        try {
            const loginRes = login.login({
                scope: true,
                domain: '',
                actId,
                force: true,
                url: formatLocaltionUrl(),
            });
            if (loginRes) {
                await sleep(60 * 1000);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 * 高授权登录类
 */
export class HighAuthLogin {
    constructor(actId) {
        /** 高授权业务 */
        this.business = '';
        /** 检查登录的活动 id */
        this.loginActId = '';
        // 根据 url 设置当前高授权业务
        this.business = url.getUrlPathName();
        this.loginActId = actId;
    }
    /**
     * 检查是否需要高授权
     */
    async checkIsNeedHighAuthLogin() {
        var _a;
        // 最近没有登录过
        if (!this.isHighAuthLoginRecently()) {
            // 调用后端接口检查高授权
            const [err] = await to(getUserInfo({ actId: this.loginActId }));
            // 没有高授权
            if (((_a = err) === null || _a === void 0 ? void 0 : _a.retcode) === '8598998014') {
                return true;
            }
            return false;
        }
        return false;
    }
    /**
     * 进行高授权
     * @param data 需要缓存的数据
     */
    async goHighAuthLogin(data) {
        // 1. 同意 自动刷页面 =》 自动操作
        // 2. 拒绝 用户点击按钮 =》 主动操作
        // 3. 拒绝 用户主动刷新页面 正常刷新 =》 用户点击按钮 =》 主动操作
        console.log('******进行高授权', data || 'defaultContent');
        // 暂存信息
        this.setHighAuthLoginInfo(data || 'defaultContent');
        // 设置进入页面后尝试登录过
        this.setIsLogin('1');
        // 进行登录
        await handleLogin(this.loginActId);
    }
    /**
     * 登录后操作
     * @param callback 回调处理
     */
    afterHighAuthLogin(callback) {
        // 获取缓存的信息
        const highLoginInfo = this.getHighAuthLoginInfo();
        /**
         * 1. 上次登录过高授权
         * 2. 有记录登录信息
         * 3. 来自高授权刷新
         */
        if (this.isHighAuthLoginRecently() && highLoginInfo && isFromHighAuth()) {
            console.log('******高授权返回进行操作', highLoginInfo);
            // 回调处理，返回信息
            callback(highLoginInfo);
            // 清空数据
            this.setHighAuthLoginInfo('');
        }
    }
    /**
     * 检查进入页面后是否尝试登录过
     * @returns
     */
    isHighAuthLoginRecently() {
        return !!sessionStorage.getItem(IS_HIGH_LOGIN, this.business);
    }
    /**
     * 设置进入页面后尝试登录过
     */
    setIsLogin(data) {
        sessionStorage.setItem(IS_HIGH_LOGIN, data, this.business);
    }
    /**
     * 设置高授权登录缓存的业务信息
     * @param data
     */
    setHighAuthLoginInfo(data) {
        sessionStorage.setItem(HIGH_LOGIN_DATA, data, this.business);
    }
    /**
     * 根据页面获取高授权登录缓存的业务信息
     * @returns
     */
    getHighAuthLoginInfo() {
        const data = sessionStorage.getItem(HIGH_LOGIN_DATA, this.business);
        if (data) {
            return data;
        }
        return null;
    }
}
